import { render } from "./HeroiconsSolidBackspace.vue?vue&type=template&id=cb571f60"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBackspace.vue"]])

export default __exports__